/**
 * Finance Hub.
 *
 * Tax and fee scheme configuration, certificate requirements, and
 * currency exchange rate management — focused on financial rules.
 */

import { Link } from "react-router-dom";
import { Receipt, ArrowRightLeft, ArrowLeft } from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import TaxSchemesPage from "@/pages/TaxSchemesPage";
import ExchangeRatesPage from "@/pages/ExchangeRatesPage";

const tabs = [
  { key: "tax-schemes", label: "Tax & Fee Schemes", icon: Receipt },
  { key: "exchange-rates", label: "Exchange Rates", icon: ArrowRightLeft },
];

function AdminFinanceHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "tax-schemes");

  return (
    <div className="page-content space-y-6">
      <div className="flex items-start gap-4">
        <Link
          to="/admin"
          className="mt-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-secondary)] transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h2 className="text-2xl font-bold text-[var(--text-primary)]">
            Finance
          </h2>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">
            Configure tax and fee rules, certificate requirements, and currency
            exchange rates.
          </p>
        </div>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "tax-schemes" && <TaxSchemesPage />}
      {activeTab === "exchange-rates" && <ExchangeRatesPage />}
    </div>
  );
}

export default AdminFinanceHub;
